// Country registry (client-side minimal metadata) driving the dynamic region
// label ("State" vs "Province" vs "Emirate" ...) and default currency for the
// Location section of the Profile page and Onboarding wizard.
//
// This mirrors the backend `/backend/localization/registry.py`, but only stores
// what the UI needs. All authoritative behavior still lives on the backend.

export const COUNTRIES = [
  { code: "US", name: "United States", regionLabel: "State", currency: "USD" },
  { code: "CA", name: "Canada", regionLabel: "Province/Territory", currency: "CAD" },
  { code: "MX", name: "Mexico", regionLabel: "Estado", currency: "MXN" },
  { code: "GB", name: "United Kingdom", regionLabel: "Country/Region", currency: "GBP" },
  { code: "IE", name: "Ireland", regionLabel: "County", currency: "EUR" },
  { code: "DE", name: "Germany", regionLabel: "Bundesland", currency: "EUR" },
  { code: "FR", name: "France", regionLabel: "Région", currency: "EUR" },
  { code: "ES", name: "Spain", regionLabel: "Comunidad Autónoma", currency: "EUR" },
  { code: "IT", name: "Italy", regionLabel: "Regione", currency: "EUR" },
  { code: "NL", name: "Netherlands", regionLabel: "Provincie", currency: "EUR" },
  { code: "CH", name: "Switzerland", regionLabel: "Canton", currency: "CHF" },
  { code: "SE", name: "Sweden", regionLabel: "Län", currency: "SEK" },
  { code: "AE", name: "United Arab Emirates", regionLabel: "Emirate", currency: "AED" },
  { code: "SA", name: "Saudi Arabia", regionLabel: "Region", currency: "SAR" },
  { code: "IL", name: "Israel", regionLabel: "District", currency: "ILS" },
  { code: "IN", name: "India", regionLabel: "State/UT", currency: "INR" },
  { code: "PK", name: "Pakistan", regionLabel: "Province", currency: "PKR" },
  { code: "BD", name: "Bangladesh", regionLabel: "Division", currency: "BDT" },
  { code: "SG", name: "Singapore", regionLabel: "Region", currency: "SGD" },
  { code: "MY", name: "Malaysia", regionLabel: "State", currency: "MYR" },
  { code: "PH", name: "Philippines", regionLabel: "Region", currency: "PHP" },
  { code: "ID", name: "Indonesia", regionLabel: "Provinsi", currency: "IDR" },
  { code: "JP", name: "Japan", regionLabel: "Prefecture", currency: "JPY" },
  { code: "KR", name: "South Korea", regionLabel: "Province", currency: "KRW" },
  { code: "HK", name: "Hong Kong", regionLabel: "District", currency: "HKD" },
  { code: "AU", name: "Australia", regionLabel: "State/Territory", currency: "AUD" },
  { code: "NZ", name: "New Zealand", regionLabel: "Region", currency: "NZD" },
  { code: "BR", name: "Brazil", regionLabel: "Estado", currency: "BRL" },
  { code: "AR", name: "Argentina", regionLabel: "Provincia", currency: "ARS" },
  { code: "CL", name: "Chile", regionLabel: "Región", currency: "CLP" },
  { code: "CO", name: "Colombia", regionLabel: "Departamento", currency: "COP" },
  { code: "ZA", name: "South Africa", regionLabel: "Province", currency: "ZAR" },
  { code: "NG", name: "Nigeria", regionLabel: "State", currency: "NGN" },
  { code: "KE", name: "Kenya", regionLabel: "County", currency: "KES" },
  { code: "EG", name: "Egypt", regionLabel: "Governorate", currency: "EGP" },
  { code: "TR", name: "Türkiye", regionLabel: "İl", currency: "TRY" },
  { code: "RU", name: "Russia", regionLabel: "Federal subject", currency: "RUB" },
];

export function getCountry(code) {
  if (!code) return null;
  return COUNTRIES.find((c) => c.code === code.toUpperCase()) || null;
}

export function regionLabelFor(code) {
  const c = getCountry(code);
  return c?.regionLabel || "Region";
}

// Small currated list of common ISO 4217 codes so users can pick a currency
// distinct from their country default.
export const CURRENCIES = [
  "USD", "EUR", "GBP", "CAD", "AUD", "JPY", "CNY", "INR", "SGD", "HKD",
  "AED", "SAR", "CHF", "SEK", "NOK", "DKK", "NZD", "ZAR", "BRL", "MXN",
  "ARS", "CLP", "COP", "PHP", "IDR", "MYR", "THB", "VND", "KRW", "TRY",
  "PLN", "CZK", "HUF", "ILS", "EGP", "NGN", "KES", "PKR", "BDT", "RUB",
];
